import {
	Component,
	OnInit,
	ViewChild
} from '@angular/core'
import { NgForm } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'
import { UserAdmin } from 'src/app/models/UserAdmin'
import { HandlerOperationService } from 'src/app/services/handler.operation.service'
import { SpeciesService } from 'src/app/services/species.service'
import {
	getIdentifierName,
	getLoggedUser
} from 'src/app/_helpers/LocalStorage'
import { OperationServiceScheduleReport } from 'src/app/models/OperationReport'
import { OperationServiceService } from 'src/app/services/operation.service.service'
import { startupPuppeteerLoading } from 'src/app/services/puppeteer-server.service'
import { TreeService } from 'src/app/services/tree.service'
import { removeToolTip } from 'src/app/_helpers/Utils'

@Component({
	selector: 'app-operation-service-schedule-report-arboreal',
	templateUrl: './operation-service-schedule-report-arboreal.component.html'
})
export class OperationServiceScheduleReportArborealComponent implements OnInit {

	constructor(
		private routeActive: ActivatedRoute,
		private operationService: OperationServiceService,
		public handlerOperationService: HandlerOperationService,
		public treeService: TreeService,
		public speciesService: SpeciesService
	) {}

	@ViewChild('form') public form: NgForm

	public companyId: string = localStorage.getItem('companyId')
	public identifierName: string = getIdentifierName()
	public sessionUser: UserAdmin = getLoggedUser()

	public reports: Array<OperationServiceScheduleReport> = []

	public isLoading: boolean = true
	public permission: boolean = true
	public switchProgress: boolean = false
	public isAdmin: boolean = false

	public placeholder: string = 'assets/images/placeholder_report.svg'
	public percentReportReceived: number = 0
	public operationServiceScheduleIds: Array<string> = []
	public numberOfPages: Array<string> = []

	public openModalChoosePrint: boolean = false

	public ngOnInit(): void {

		this.isAdmin =
			this.sessionUser.roles.includes('GENERAL_ADMIN') ||
			this.sessionUser.roles.includes('CUSTOMER')

		const ids: string =
			this.routeActive.snapshot.paramMap.get('operationsId')

		this.operationServiceScheduleIds = ids.split(',')

		this.getReports(this.operationServiceScheduleIds)
	}

	public async getReports(ids: Array<string>) {

		const parts = this.arrayPartition(ids)

		let limitProgressUntilAwaitRequest: number = 0

		for (const part of parts) {
			limitProgressUntilAwaitRequest += Math.floor(part.length / ids.length * 100)

			this.progressPercentReceived(limitProgressUntilAwaitRequest)

			try {
				const reports: Array<OperationServiceScheduleReport> =
					await this.operationService.getOperationServiceScheduleReportArboreal(part).toPromise()

				this.reports = [...this.reports, ...reports]
				this.switchProgress = !this.switchProgress
			} catch (err) {
				console.log('Error', err)
				if (parts.length == 1) {
					this.permission = false
					break
				}
			}
		}

		this.stopProgressPercentReceived()
		this.isLoading = false

		startupPuppeteerLoading(document)
	}

	public stopProgressPercentReceived() {
		this.switchProgress = !this.switchProgress
		this.percentReportReceived = 100
	}

	public progressPercentReceived(limit: number) {

		const switchNow: boolean = this.switchProgress

		const intervalId = setInterval(() => {
			if (switchNow != this.switchProgress || this.percentReportReceived >= limit) {
				clearInterval(intervalId)
			}

			this.percentReportReceived < 99 && this.percentReportReceived++
		}, 280)
	}

	public arrayPartition(array: Array<string>) {
		const parts = []

		for (let i = 0; i < array.length; i += 10) {
			const part = array.slice(i, i + 10)
			parts.push(part)
		}

		return parts
	}

	public async getPageHeight() {
		let pageHeight = 0

		function findHighestNode(nodesList) {
			for (let i = nodesList.length - 1; i >= 0; i--) {
				if (nodesList[i].scrollHeight && nodesList[i].clientHeight) {
					const elHeight = Math.max(
						nodesList[i].scrollHeight,
						nodesList[i].clientHeight
					)
					pageHeight = Math.max(elHeight, pageHeight)
				}
				if (nodesList[i].childNodes.length) {
					findHighestNode(nodesList[i].childNodes)
				}
			}
		}

		findHighestNode(document.documentElement.childNodes)

		// The entire page height is found
		this.numberOfPages = Array(Math.round(pageHeight / 1361))

		for (let index = 1; index <= this.numberOfPages.length; index++) {
			this.numberOfPages[index - 1] = `${index < 10 ? '0' : ''}${index}`
		}
	}

	public openSelectionModeModal() {
		removeToolTip()
		this.openModalChoosePrint = !this.openModalChoosePrint
	}

	public async exportReport() {
		const type = 'schedule-operation-report-arboreal'
		const ids = this.reports.map(report => report.idMongo)

		this.treeService.exportReport({type, ids})

		this.openSelectionModeModal()
	}

	public async printOut() {
		this.openSelectionModeModal()

		if (this.numberOfPages.length == 0) {
			this.getPageHeight()
		}

		setTimeout(() => {
			window.print()
		}, 200)
	}

	public reloadWindow() {
				setTimeout(() => {
						window.location.reload()
				}, 500)
		}
}
